import { SwitchSchemaConstants } from './utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, IconButton } from '@mui/material';
import { MaterialUISwitch } from './SwitchShema.styled';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';

const SchemaModal = ({
  place_id,
  lights,
  handleLightChange,
  handleDoorOpen,
  lightsStateLoaded,
  isUpdating,
}) => {
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const isMediumScreen = useMediaQuery('(max-width:960px)');

  console.log(place_id);
  console.log(SwitchSchemaConstants[place_id]);
  console.log(lights);
  return (
    <>
      {SwitchSchemaConstants[place_id]?.lights?.map((styles, index) => (
        <>
          {lights && (
            <Box
              sx={{
                position: 'absolute',
                width: styles.width,
                height: styles.height,
                top: styles.top,
                left: styles.left,
                transform: 'translate(-50%, -50%)',
              }}
            >
              <MaterialUISwitch
                disabled={!lightsStateLoaded || isUpdating}
                checked={lights[index + 1]}
                onChange={handleLightChange(index + 1)}
                isSmallScreen={isSmallScreen}
                isMediumScreen={isMediumScreen}
                sx={{
                  top: styles.switchStyles.top,
                  left: isSmallScreen
                    ? styles.switchStyles.leftSm
                    : isMediumScreen
                    ? styles.switchStyles.leftMd
                    : styles.switchStyles.leftLg,
                }}
              />
            </Box>
          )}
        </>
      ))}
      {SwitchSchemaConstants[place_id]?.doors?.map((styles, index) => (
        <>
          <Box
            sx={{
              position: 'absolute',
              width: styles.width,
              height: styles.height,
              top: styles.top,
              left: styles.left,
              // transform: 'translate(-50%, -50%)',
            }}
          >
            <IconButton
              disabled={!lightsStateLoaded || isUpdating}
              onClick={handleDoorOpen}
              sx={{
                top: isSmallScreen ? styles.doorStyles.topSm : styles.doorStyles.topLg,
                left: isSmallScreen ? styles.doorStyles.leftSm : styles.doorStyles.leftLg,
                color: isUpdating ? '#aab4be' : '#fff972',
              }}
            >
              <MeetingRoomIcon fontSize={isSmallScreen ? 'small' : 'large'} />
            </IconButton>
          </Box>
        </>
      ))}
    </>
  );
};

export default SchemaModal;
